import { LoginState, AppState, LoggedOutState, isLoggedOutState, LoggedInState, isLoggedInState } from './state';
import { Widget, Action, onlyIf, string, any, nothing, div, button } from "widgets-for-react";
import { getClassName } from '../utils/utils.mod';
import { LoginFlowStyle } from './pages/style.mod';
import i18next = require('i18next');

function errorMessages<a, extra_user_info>(value: LoginState<a, extra_user_info>): string {
  switch (value.status) {
    case "change password - error incorrect password":
      return `${i18next.t(`loginflow:notifications.change_password.incorrect_password`)}`
    case "change password - error too weak password":
      return `${i18next.t(`loginflow:notifications.change_password.too_weak`)}`
    case "choose role - error no role selected":
      return `${i18next.t(`loginflow:notifications.choose_role.no_role_selected`)}`
    case "logged out - error login not authorized":
      return `${i18next.t(`loginflow:notifications.logged_out.not_authorized`)}`
    case "logged out - error too many attempts":
      return `${i18next.t(`loginflow:notifications.logged_out.too_many_attempts`)}`
    case "logged out - error account not active":
      return `${i18next.t(`loginflow:notifications.logged_out.account_not_active`)}`
    case "reset password request - error user not activated":
      return `${i18next.t(`loginflow:notifications.reset_password_request.account_not_active`)}`
    case "reset password - error weak password":
      return `${i18next.t(`loginflow:notifications.reset_password.too_weak`)}`
    case "sign up - error weak password":
      return `${i18next.t(`loginflow:notifications.sign_up.too_weak`)}`
    case "sign up - error too many attempts":
      return `${i18next.t(`loginflow:notifications.sign_up.too_many_attempts`)}`
    default:
      return `${i18next.t(`loginflow:notifications.default`)}`
  }
}

export let notifications = <a, b extends {kind:string}, extra_user_info>(
  s0:LoginState<a, extra_user_info>,
  options? : { style?: LoginFlowStyle; key?: string }
): Widget<Action<AppState<a, b, extra_user_info>>> => {
  return onlyIf(s0.status.includes("error") && !(s0.status.includes("too many attempts")),
    div<Action<AppState<a, b, extra_user_info>>>()([
      div<Action<AppState<a, b, extra_user_info>>>({
        key: "notifications-0",
        role: "alert",
        className: getClassName(
          options,
          "form_error_classname",
          "alert alert-danger small"
        )
      })(
        string({ readonly_element:"p", readonly:true })(errorMessages(s0)).never()
      )
    ]))
}